export default {
  brand: {
    fileShare: 'Compartilhamento de Arquivos'
  },
  common: {
    loading: 'Carregando...',
    confirm: 'Confirmar',
    cancel: 'Cancelar',
    download: 'Baixar',
    downloadAll: 'Baixar tudo',
    downloadSelected: 'Baixar selecionados',
    selectAll: 'Selecionar tudo',
    deselectAll: 'Desselecionar',
    rootDirectory: 'Diretório raiz',
    createTime: 'Criado em',
    expireTime: 'Expira em',
    totalSize: 'Tamanho total',
    noFiles: 'Nenhum arquivo'
  },
  share: {
    expired: 'Os arquivos compartilhados expiraram',
    invalidLink: 'Link de compartilhamento inválido',
    needVerifyCode: 'Por favor, insira o código de extração',
    verifyCodeLabel: 'Código',
    verifyCodePlaceholder: 'Insira o código de extração',
    extractFiles: 'Extrair arquivos',
    extractionCodeError: 'Código de extração incorreto',
    uuidRequestFailed: 'Falha na solicitação de download',
    selectFilesFirst: 'Por favor, selecione os arquivos primeiro',
    unknownError: 'Erro desconhecido'
  },
  error: {
    networkError: 'Erro de rede',
    connectionFailed: 'Não é possível conectar ao dispositivo de compartilhamento. O dispositivo pode estar desligado, em suspensão ou a região de serviço pode ter mudado. Por favor, entre em contato com quem compartilhou.',
    outdatedLink: 'Não é possível conectar ao dispositivo de compartilhamento. Um link de compartilhamento desatualizado pode ter sido usado. Por favor, peça a quem compartilhou para atualizar o sistema para v2.0.10 ou superior, o APP para v2.1.5 ou superior e copiar novamente o link de compartilhamento.',
    registryError: 'Erro ao obter configurações de penetração de rede pública. Não é possível conectar ao serviço de Registro.',
    missingRegion: 'Falta informação de região de serviço no link de compartilhamento. Por favor, peça a quem compartilhou para atualizar o sistema para v2.0.10 ou superior, o APP para v2.1.5 ou superior e copiar novamente o link de compartilhamento.'
  }
}
